import axios from 'axios';

const EMAIL_API_BASE_URL =
  process.env.REACT_APP_EMAIL_API_BASE_URLTWO || process.env.REACT_APP_EMAIL_API_BASE_URL ;

const EMAIL_RECEIVER = process.env.REACT_APP_EMAIL_RECEIVER;
const EMAIL_FROM = process.env.REACT_APP_EMAIL_FROM;

function requireEmailConfig() {
  if (!EMAIL_RECEIVER || !EMAIL_FROM) {
    const missing = [
      !EMAIL_RECEIVER ? 'REACT_APP_EMAIL_RECEIVER' : null,
      !EMAIL_FROM ? 'REACT_APP_EMAIL_FROM' : null,
    ].filter(Boolean);

    throw new Error(`Missing email config: ${missing.join(', ')}`);
  }

  return { receiver: EMAIL_RECEIVER, from: EMAIL_FROM };
}

function escapeHtml(value) {
  return String(value)
    .replaceAll('&', '&amp;')
    .replaceAll('<', '&lt;')
    .replaceAll('>', '&gt;')
    .replaceAll('"', '&quot;')
    .replaceAll("'", '&#39;');
}

function textToHtmlParagraphs(text) {
  const safe = escapeHtml(text);
  // Preserve newlines in email clients
  return safe.replaceAll('\n', '<br />');
}

export async function sendContactEmail({ name, email, message }) {
  const { receiver, from } = requireEmailConfig();

  return axios.post(
    `${EMAIL_API_BASE_URL}/send`,
    {
      name,
      email,
      message,
      receiver,
      from,
    },
    {
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
      },
    }
  );
}

export function buildQuoteHtml({
  name,
  email,
  phone,
  location,
  serviceType,
  budget,
  timeline,
  message,
}) {
  const safeMessage = textToHtmlParagraphs(message);

  const infoRows = [];

  function addRow(label, value) {
    if (!value) return;
    infoRows.push(`
                  <tr>
                    <td style="padding:10px 12px;border:1px solid #e7e9f3;background:#fafbff;width:140px;font-weight:700;color:#0f172a;">${escapeHtml(label)}</td>
                    <td style="padding:10px 12px;border:1px solid #e7e9f3;color:#0f172a;">${escapeHtml(value)}</td>
                  </tr>`);
  }

  addRow('Name', name);
  addRow('Email', email);
  addRow('Phone', phone);
  addRow('Location', location);
  addRow('Service Type', serviceType);
  addRow('Budget', budget);
  addRow('Timeline', timeline);

  return `<!doctype html>
<html lang="en">
  <head>
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width,initial-scale=1" />
    <title>Quote Request</title>
  </head>
  <body style="margin:0;padding:0;background:#f6f7fb;font-family:Arial,Helvetica,sans-serif;">
    <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="background:#f6f7fb;padding:24px 12px;">
      <tr>
        <td align="center">
          <table role="presentation" width="640" cellpadding="0" cellspacing="0" style="width:640px;max-width:100%;background:#ffffff;border-radius:14px;overflow:hidden;border:1px solid #e7e9f3;">
            <tr>
              <td style="padding:18px 22px;background:#0f172a;color:#ffffff;">
                <div style="font-size:14px;opacity:0.9;">Divine-Tech Engineering</div>
                <div style="font-size:22px;font-weight:700;margin-top:4px;">New Quote Request</div>
              </td>
            </tr>
            <tr>
              <td style="padding:22px;">
                <div style="font-size:14px;color:#0f172a;opacity:0.9;">Customer details</div>
                <table role="presentation" width="100%" cellpadding="0" cellspacing="0" style="margin-top:12px;border-collapse:collapse;">
                  ${infoRows.join('')}
                </table>

                <div style="margin-top:18px;font-size:14px;color:#0f172a;opacity:0.9;">Message</div>
                <div style="margin-top:10px;padding:14px 14px;border:1px solid #e7e9f3;background:#fafbff;border-radius:12px;color:#0f172a;line-height:1.55;font-size:14px;">
                  ${safeMessage}
                </div>

              </td>
            </tr>
            <tr>
              <td style="padding:14px 22px;background:#f8fafc;color:#334155;font-size:12px;">
                Sent via DTE website quote form.
              </td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
  </body>
</html>`;
}

export async function sendQuoteEmail({
  name,
  email,
  phone,
  location,
  serviceType,
  budget,
  timeline,
  message,
}) {
  const { receiver, from } = requireEmailConfig();

  const details = {
    phone,
    location,
    serviceType,
    budget,
    timeline,
  };

  const plainMessage = [
    serviceType ? `Service Type: ${serviceType}` : null,
    location ? `Location: ${location}` : null,
    phone ? `Phone: ${phone}` : null,
    budget ? `Budget: ${budget}` : null,
    timeline ? `Timeline: ${timeline}` : null,
    null,
    message,
  ]
    .filter((line) => line !== null)
    .join('\n');

  const html = buildQuoteHtml({ name, email, message, ...details });

  return axios.post(
    `${EMAIL_API_BASE_URL}/send-html`,
    {
      name,
      email,
      message: plainMessage,
      receiver,
      html,
      from,
    },
    {
      headers: {
        accept: '*/*',
        'Content-Type': 'application/json',
      },
    }
  );
}
